import { Area } from 'react-easy-crop';

export interface ICropOptions {
  format?: 'image/jpeg' | 'image/png' | 'image/webp';
  quality?: number;
  outputType?: 'blob' | 'base64' | 'file';
  fileName?: string;
}

const createImage = (url: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(new Error(error.message)));
    image.src = url;
  });
};

const getCroppedImg = async (
  imageSrc: string,
  pixelCrop: Area,
  options?: ICropOptions
): Promise<Blob | string | File> => {
  const { format = 'image/webp', quality = 0.75, outputType = 'blob', fileName } = options ?? {};

  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) throw new Error('No se pudo obtener el contexto 2D del canvas');

  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  if (outputType === 'base64') {
    const fullDataUrl = canvas.toDataURL(format, quality);

    return fullDataUrl.split(',')[1];
  }

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('Error al generar el Blob'))),
      format,
      quality
    );
  });

  return outputType === 'file'
    ? new File([blob], fileName ?? 'cropped-image.jpg', { type: format })
    : blob;
};

export { getCroppedImg };
